import { render, staticRenderFns } from "./ReviewTopBlock.vue?vue&type=template&id=1d78f890&scoped=true&"
import script from "./ReviewTopBlock.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewTopBlock.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewTopBlock.vue?vue&type=style&index=0&id=1d78f890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d78f890",
  null
  
)

export default component.exports